'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VForm = undefined;

var _VForm = require('./VForm');

var _VForm2 = _interopRequireDefault(_VForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VForm = _VForm2.default;
exports.default = _VForm2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VForm/index.js
// module id = 184
// module chunks = 0